'use strict';
import angular from 'angular';
/**
 * The Util service is for thin, globally reusable, utility functions
 */
export function UtilService($window, $cacheFactory, $log) {
    'ngInject';
    var Util = {
        /**
         * Return a callback or noop function
         *
         * @param  {Function|*} cb - a 'potential' function
         * @return {Function}
         */
        safeCb: function (cb) {
            return angular.isFunction(cb) ? cb : angular.noop;
        },
        /**
         * Parse a given url with the use of an anchor element
         *
         * @param  {String} url - the url to parse
         * @return {Object}     - the parsed url, anchor element
         */
        urlParse: function (url) {
            var a = document.createElement('a');
            a.href = url;
            // Special treatment for IE, see http://stackoverflow.com/a/13405933 for details
            if (a.host === '') {
                a.href = a.href;
            }
            return a;
        },
        /**
         * Removes specific api endpoint data from angular's cache
         *
         * @param {String} url - the endpoint for the cached data to remove (i.e. 'api/account')
         */
        removeCacheForEndPoint: function (url) {
            if (!url)
                return;
            var $httpDefaultCache = $cacheFactory.get('$http');
            $httpDefaultCache.remove(url);
        },
        setPageErrors: function (error, errType, self) {
            self.errors = {};
            self.errors.pageErrorType = errType;
            self.errors.pageErrors = error;
            self.errors.havePageErrors = true;
        },
        handleApiError: function (response, self) {
            if (response && response.data && response.data.errors && response.data.errors.length) {
                this.setPageErrors(response.data.errors, 'api', self);
            }
            else {
                var mesg = response && response.statusText != ''
                    ? response.statusText
                    : "Oops. We are having a technical issue right now. Please try again later or call Customer Support\n            for assistance 800.654.4432";
                var errs = response ? [{ code: response.status, message: mesg + ' | ' + (response.data ? response.data : '') }] : {};
                this.setPageErrors(errs, 'api', self);
            }
            self.showAlert = true;
        },
        resetApiError: function (self) {
            self.showAlert = false;
            if (self.errors) {
                self.errors.havePageErrors = false;
                self.errors.pageErrors = '';
                self.errors.pageErrorType = '';
            }
        },
        handleApiResponse: function (promise, self, thenHandler, errorHandler) {
            var _this = this;
            thenHandler = thenHandler || function (response) { return response; };
            errorHandler = errorHandler || function (response) { return response; };
            var res = null;
            return promise.then(function (response) {
                res = response;
                if (response.status != 200 || response.data.errors.length) {
                    throw new Error('uh oh' + response.data.errors);
                }
                _this.resetApiError(self);
                return thenHandler(response);
            }).catch(function (e) {
                _this.handleApiError(res, self);
                $log.debug('sad api response:', e);
                return errorHandler(res);
            });
        },
        /**
         * Test whether or not a given url is same origin
         *
         * @param  {String}           url       - url to test
         * @param  {String|String[]}  [origins] - additional origins to test against
         * @return {Boolean}                    - true if url is same origin
         */
        isSameOrigin: function (url, origins) {
            url = Util.urlParse(url);
            origins = origins && [].concat(origins) || [];
            origins = origins.map(Util.urlParse);
            origins.push($window.location);
            origins = origins.filter(function (o) {
                var hostnameCheck = url.hostname === o.hostname;
                var protocolCheck = url.protocol === o.protocol;
                // 2nd part of the special treatment for IE fix (see above):
                // This part is when using well-known ports 80 or 443 with IE,
                // when $window.location.port==='' instead of the real port number.
                // Probably the same cause as this IE bug: https://goo.gl/J9hRta
                var portCheck = url.port === o.port || o.port === '' && (url.port === '80' || url.port ===
                    '443');
                return hostnameCheck && protocolCheck && portCheck;
            });
            return origins.length >= 1;
        },
        handleSuccess: function (response) {
            return response;
        },
        handleError: function (response) {
            return response;
        },
        flattenWarnings: function (warnings) {
            var flatWarnings = [];
            angular.forEach(warnings, function (warning) {
                console.log('util#flattenWarnings:', warning.message);
                if (warning.message && warning.message !== '') {
                    flatWarnings.push(warning.message);
                }
            });
            return flatWarnings;
        }
    };
    return Util;
}
//# sourceMappingURL=util.service.js.map